import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance_0,
  ImageScaleType_Fit_getInstance3ce22z7h47ouq as ImageScaleType_Fit_getInstance,
  Dimension__compareTo_impl_gsceod30y54irsnvl8x as Dimension__compareTo_impl_gsceod,
  Dimensions32ju1l7z4mh as Dimension,
  MinWidthmy5c27t0vx62 as MinWidth,
  MaxWidth3w3zqziye9hut as MaxWidth,
  And1jik66wmc7j6f as And,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { HomePage3ptt6l367zajb as HomePage } from './views/HomeScreen.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  plus2lr02ok6jhhxu as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  get_asBanner3lskqry4r3fmr as get_asBanner,
  shownForQuery3qp0gj477pgv9 as shownForQuery,
  weight31wqab1913ly4 as weight,
  get_asNavigation1puslqspkdfc0 as get_asNavigation,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  BarSemantic_getInstance1mitybcla04dq as BarSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  NavSemantic_getInstance3hcdsyfduq9gu as NavSemantic_getInstance,
  OuterSemantic_getInstance3f4lrw2322ga8 as OuterSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  UnselectedSemantic_getInstance1xc7cb2k39ftl as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  textSize2lsj2v924xul5 as textSize,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { applySafeInsets1yyre4vmrimte as applySafeInsets } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/safeInsetsHelpers.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atStart2tusd7ehy6hjj as get_atStart,
  get_atTopEnd2f4khbhwy0qa as get_atTopEnd,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { RawImageView3rlp4gsc2bxt0 as RawImageView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RawImageView.commonHtml.mjs';
import {
  SmallTextSemantic_getInstance3ht14r7yzc9rl as SmallTextSemantic_getInstance,
  NumberBadgeSemantic_getInstance2wez41hmadmon as NumberBadgeSemantic_getInstance,
} from './theme/semantics.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from './App.mjs';
import {
  rowOfExpensive14cfdwaubaywj as rowOfExpensive,
  colOfExpensive3l2ndrv33zay6 as colOfExpensive,
} from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_1 } from '../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { set_padding5v7ifiir6y9y as set_padding } from '../../../../kiteui-library/com/lightningkite/kiteui/views/Element.ext.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { navigatorView2ox898kg3o7zc as navigatorView } from '../../../../kiteui-library/com/lightningkite/kiteui/views/l2/NavigatorView.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_mainPageNavigator26bf0rvtlvnco as get_mainPageNavigator } from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/deprecated.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { onNavigate1u0nf5qj38nup as onNavigate } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.mjs';
import { onNavigate2wu3qzsseblgb as onNavigate_0 } from '../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { closePopoversckn4u815mr3s as closePopovers } from '../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GroupClass;
function Group() {
  if (GroupClass === VOID) {
    class $ {
      constructor(title, icon, children, fullTitle, count) {
        fullTitle = fullTitle === VOID ? title : fullTitle;
        count = count === VOID ? null : count;
        this.title_1 = title;
        this.icon_1 = icon;
        this.children_1 = children;
        this.fullTitle_1 = fullTitle;
        this.count_1 = count;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_count_ipufhi_k$() {
        return this.count_1;
      }
      toString() {
        return 'Group(title=' + this.title_1 + ', icon=' + this.icon_1.toString() + ', children=' + toString(this.children_1) + ', fullTitle=' + this.fullTitle_1 + ', count=' + this.count_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.title_1);
        result = imul(result, 31) + this.icon_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.children_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.fullTitle_1) | 0;
        result = imul(result, 31) + (this.count_1 == null ? 0 : this.count_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Group()))
          return false;
        if (!(this.title_1 === other.title_1))
          return false;
        if (!this.icon_1.equals(other.icon_1))
          return false;
        if (!equals(this.children_1, other.children_1))
          return false;
        if (!(this.fullTitle_1 === other.fullTitle_1))
          return false;
        if (!(this.count_1 == other.count_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Group');
    GroupClass = $;
  }
  return GroupClass;
}
var LinkClass;
function Link_0() {
  if (LinkClass === VOID) {
    class $ {
      constructor(title, fullTitle, icon, count, to) {
        fullTitle = fullTitle === VOID ? title : fullTitle;
        icon = icon === VOID ? null : icon;
        count = count === VOID ? null : count;
        this.title_1 = title;
        this.fullTitle_1 = fullTitle;
        this.icon_1 = icon;
        this.count_1 = count;
        this.to_1 = to;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_count_ipufhi_k$() {
        return this.count_1;
      }
      toString() {
        return 'Link(title=' + this.title_1 + ', fullTitle=' + this.fullTitle_1 + ', icon=' + toString_0(this.icon_1) + ', count=' + this.count_1 + ', to=' + toString(this.to_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.title_1);
        result = imul(result, 31) + getStringHashCode(this.fullTitle_1) | 0;
        result = imul(result, 31) + (this.icon_1 == null ? 0 : this.icon_1.hashCode()) | 0;
        result = imul(result, 31) + (this.count_1 == null ? 0 : this.count_1) | 0;
        result = imul(result, 31) + hashCode(this.to_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Link_0()))
          return false;
        if (!(this.title_1 === other.title_1))
          return false;
        if (!(this.fullTitle_1 === other.fullTitle_1))
          return false;
        if (!equals(this.icon_1, other.icon_1))
          return false;
        if (!(this.count_1 == other.count_1))
          return false;
        if (!equals(this.to_1, other.to_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Link');
    LinkClass = $;
  }
  return LinkClass;
}
var ExternalClass;
function External() {
  if (ExternalClass === VOID) {
    class $ {}
    initMetadataForClass($, 'External');
    ExternalClass = $;
  }
  return ExternalClass;
}
var ActionClass;
function Action() {
  if (ActionClass === VOID) {
    class $ {
      constructor(title, icon, count, onSelect) {
        count = count === VOID ? null : count;
        this.title_1 = title;
        this.icon_1 = icon;
        this.count_1 = count;
        this.onSelect_1 = onSelect;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_count_ipufhi_k$() {
        return this.count_1;
      }
      toString() {
        return 'Action(title=' + this.title_1 + ', icon=' + this.icon_1.toString() + ', count=' + this.count_1 + ', onSelect=' + toString(this.onSelect_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.title_1);
        result = imul(result, 31) + this.icon_1.hashCode() | 0;
        result = imul(result, 31) + (this.count_1 == null ? 0 : this.count_1) | 0;
        result = imul(result, 31) + hashCode(this.onSelect_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Action()))
          return false;
        if (!(this.title_1 === other.title_1))
          return false;
        if (!this.icon_1.equals(other.icon_1))
          return false;
        if (!(this.count_1 == other.count_1))
          return false;
        if (!equals(this.onSelect_1, other.onSelect_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Action');
    ActionClass = $;
  }
  return ActionClass;
}
var CustomClass;
function Custom() {
  if (CustomClass === VOID) {
    class $ {
      constructor(title, icon, wide, narrow) {
        icon = icon === VOID ? Companion_getInstance().moreHoriz_1 : icon;
        narrow = narrow === VOID ? wide : narrow;
        this.title_1 = title;
        this.icon_1 = icon;
        this.wide_1 = wide;
        this.narrow_1 = narrow;
      }
      get_title_iz32un_k$() {
        return this.title_1;
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_count_ipufhi_k$() {
        return null;
      }
      toString() {
        return 'Custom(title=' + this.title_1 + ', icon=' + this.icon_1.toString() + ', wide=' + toString(this.wide_1) + ', narrow=' + toString(this.narrow_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.title_1);
        result = imul(result, 31) + this.icon_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.wide_1) | 0;
        result = imul(result, 31) + hashCode(this.narrow_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Custom()))
          return false;
        if (!(this.title_1 === other.title_1))
          return false;
        if (!this.icon_1.equals(other.icon_1))
          return false;
        if (!equals(this.wide_1, other.wide_1))
          return false;
        if (!equals(this.narrow_1, other.narrow_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Custom');
    CustomClass = $;
  }
  return CustomClass;
}
function Nav$_init_$lambda_1d9huw(_this__u8e3s4) {
  return true;
}
function Nav$_init_$lambda_1d9huw_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function Nav$_init_$lambda_1d9huw_1(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function Nav$_init_$lambda_1d9huw_2(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function Button$_get_visible_$ref_mav0jg(p0) {
  return constructCallableReference(() => p0.get_visible_8zfvk9_k$(), 0, 0, 190, VOID, [p0]);
}
function Button$_set_visible_$ref_7zj5sg(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_visible_w9mvj4_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 191, VOID, [p0]);
}
function Nav$appBar$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($$this$button.get_context_h02k06_k$()).goBack_kj7lzl_k$();
    return Unit_instance;
  }), 0);
}
function Nav$appBar$lambda() {
  return new (HomePage())();
}
function Nav$rail$item$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return Unit_instance;
  }), 0);
}
function rail$item(_this__u8e3s4, $labeled, this$0, element) {
  if ($labeled) {
    renderInline(_this__u8e3s4, element, this$0, this$0.selectedPath_1, Nav$rail$item$slambda());
  } else {
    var tmp = Companion_getInstance_0().rightBottom_1;
    renderAsMenus(_this__u8e3s4, element, tmp, this$0.selectedPath_1, VOID, ($this$renderAsMenus) => {
      navStackedContent($this$renderAsMenus, element);
      return Unit_instance;
    });
  }
}
function Nav$rail$lambda() {
  return new (HomePage())();
}
function Nav$rail$lambda_0() {
  return new (HomePage())();
}
function Nav$drawer$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.drawerOpen_1.set_value_v1vabv_k$(false);
    return Unit_instance;
  }), 0);
}
function Nav$drawer$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.drawerOpen_1.set_value_v1vabv_k$(false);
    return Unit_instance;
  }), 0);
}
function Nav$drawer$lambda$slambda_0(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.drawerOpen_1.set_value_v1vabv_k$(false);
    return Unit_instance;
  }), 0);
}
var NavClass;
function Nav() {
  if (NavClass === VOID) {
    class $ {
      constructor(writer, appLogoExpanded, appLogoCompact, appLogoIcon, appName, showNav, menuItems, footerItems, actionItems) {
        appLogoCompact = appLogoCompact === VOID ? null : appLogoCompact;
        appLogoIcon = appLogoIcon === VOID ? null : appLogoIcon;
        var tmp;
        if (showNav === VOID) {
          tmp = Nav$_init_$lambda_1d9huw;
        } else {
          tmp = showNav;
        }
        showNav = tmp;
        var tmp_0;
        if (menuItems === VOID) {
          tmp_0 = Nav$_init_$lambda_1d9huw_0;
        } else {
          tmp_0 = menuItems;
        }
        menuItems = tmp_0;
        var tmp_1;
        if (footerItems === VOID) {
          tmp_1 = Nav$_init_$lambda_1d9huw_1;
        } else {
          tmp_1 = footerItems;
        }
        footerItems = tmp_1;
        var tmp_2;
        if (actionItems === VOID) {
          tmp_2 = Nav$_init_$lambda_1d9huw_2;
        } else {
          tmp_2 = actionItems;
        }
        actionItems = tmp_2;
        this.appLogoExpanded_1 = appLogoExpanded;
        this.appLogoCompact_1 = appLogoCompact;
        this.appLogoIcon_1 = appLogoIcon;
        this.appName_1 = appName;
        this.showNav_1 = showNav;
        this.items_1 = remember(VOID, VOID, VOID, VOID, menuItems);
        this.footerItems_1 = remember(VOID, VOID, VOID, VOID, footerItems);
        this.actionItems_1 = remember(VOID, VOID, VOID, VOID, actionItems);
        var tmp_3 = this;
        // Inline function 'kotlin.with' call
        tmp_3.selectedPath_1 = navSelectedPath(writer, this.items_1);
        this.drawerOpen_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        var tmp_4 = this;
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$2 = emptyMap();
        tmp_4.groupOverrides_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$2);
      }
      appBar_vbzies_k$(writer, menuButtonFor, inlineLinksFor) {
        // Inline function 'com.lightningkite.kiteui.views.bar' call
        var this_0 = shownWhen(writer, false, VOID, this.showNav_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_1 = get_asBanner(themed(this_0, BarSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(false);
        applySafeInsets(element, VOID, VOID, VOID, false);
        element.set_debugName_wihv62_k$('app bar');
        element.set_showOnPrint_2epyu7_k$(false);
        if (!get_current(Companion_instance).equals(Platform_Web_getInstance())) {
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_2 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Button())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var $this$button = element_0;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().arrowBack_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (IconView())($this$button.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          $this$button.willAddChild_hz2iwc_k$(element_1);
          element_1.set_source_3o5lkf_k$(icon);
          element_1.set_description_s1386w_k$('Go back');
          element_1.onStartup_vrxh3i_k$();
          $this$button.addChild_2qpft2_k$(element_1);
          var tmp = KMutableProperty0();
          var tmp_0 = Button$_get_visible_$ref_mav0jg($this$button);
          var tmp_1 = getPropertyCallableRef('visible', 0, tmp, tmp_0, Button$_set_visible_$ref_7zj5sg($this$button));
          $this$button.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_pageNavigator($this$button.get_context_h02k06_k$()).canGoBack_1));
          onClick($this$button, VOID, VOID, VOID, Nav$appBar$slambda($this$button));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
        }
        if (!(menuButtonFor == null)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
          var this_3 = shownForQuery(get_centered(element), menuButtonFor);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (ToggleButton())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_3.willAddChild_hz2iwc_k$(element_2);
          element_2.bind_gesskf_k$(element_2.checked_1, this.drawerOpen_1);
          var tmp2 = Companion_getInstance().menu_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var description = 'Navigation menu';
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (IconView())(element_2.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          element_2.willAddChild_hz2iwc_k$(element_3);
          element_3.set_source_3o5lkf_k$(tmp2);
          element_3.set_description_s1386w_k$(description);
          element_3.onStartup_vrxh3i_k$();
          element_2.addChild_2qpft2_k$(element_3);
          element_2.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_2);
        }
        if (!(menuButtonFor == null)) {
          var tmp0_$receiver = shownForQuery(get_centered(element), menuButtonFor);
          var tmp1_height = get_rem(2.5);
          var tmp2_width = get_rem(2.5);
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          var this_4 = get_unpadded(sizeConstraints(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, tmp2_width, tmp1_height));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (Link())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          this_4.willAddChild_hz2iwc_k$(element_4);
          var tmp0_elvis_lhs = this.appLogoIcon_1;
          var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.appLogoCompact_1 : tmp0_elvis_lhs;
          var tmp2_0 = tmp1_elvis_lhs == null ? this.appLogoExpanded_1 : tmp1_elvis_lhs;
          // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
          var description_0 = this.appName_1;
          var scaleType = ImageScaleType_Fit_getInstance();
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_5 = new (RawImageView())(element_4.get_context_h02k06_k$(), tmp2_0, description_0, scaleType);
          ensureOutermostElement(element_5);
          element_4.willAddChild_hz2iwc_k$(element_5);
          element_5.onStartup_vrxh3i_k$();
          element_4.addChild_2qpft2_k$(element_5);
          element_4.set_accessibleLabel_97wje2_k$(this.appName_1 + ' home');
          element_4.set_to_opdqsp_k$(Nav$appBar$lambda);
          element_4.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_4);
        }
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_5 = get_centered(element);
        var tmp$ret$27 = weight(this_5, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_6 = themed(tmp$ret$27, SmallTextSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_6.willAddChild_hz2iwc_k$(element_6);
        var $this$text = element_6;
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl($this$text);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb($this$text));
        $this$text.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(get_pageNavigator($this$text.get_context_h02k06_k$()).currentPage_1);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_title_iz32un_k$();
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = $this$invoke.invoke_r7m7el_k$(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        $this$text.set_wraps_9wisy1_k$(false);
        $this$text.set_ellipsis_rhzl3b_k$(true);
        element_6.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_6);
        if (!(inlineLinksFor == null)) {
          var tmp_5 = themed(shownForQuery(get_centered(element), inlineLinksFor), ListSemantic_getInstance());
          rowOfExpensive(tmp_5, this.items_1, VOID, ($this$rowOfExpensive, element) => {
            var tmp = Companion_getInstance_0().belowLeft_1;
            renderAsMenus($this$rowOfExpensive, element, tmp, this.selectedPath_1, VOID, ($this$renderAsMenus) => {
              navTextContent($this$renderAsMenus, element);
              return Unit_instance;
            });
            return Unit_instance;
          });
        }
        var tmp_6 = themed(get_centered(element), ListSemantic_getInstance());
        rowOfExpensive(tmp_6, this.actionItems_1, VOID, ($this$rowOfExpensive, element) => {
          var tmp = Companion_getInstance_0().belowLeft_1;
          renderAsMenus($this$rowOfExpensive, element, tmp, this.selectedPath_1, VOID, ($this$renderAsMenus) => {
            navIconContent($this$renderAsMenus, element);
            return Unit_instance;
          });
          return Unit_instance;
        });
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
      }
      appBar$default_61bzdt_k$(writer, menuButtonFor, inlineLinksFor, $super) {
        menuButtonFor = menuButtonFor === VOID ? null : menuButtonFor;
        inlineLinksFor = inlineLinksFor === VOID ? null : inlineLinksFor;
        var tmp;
        if ($super === VOID) {
          this.appBar_vbzies_k$(writer, menuButtonFor, inlineLinksFor);
          tmp = Unit_instance;
        } else {
          tmp = $super.appBar_vbzies_k$.call(this, writer, menuButtonFor, inlineLinksFor);
        }
        return tmp;
      }
      rail_uvsimf_k$(writer, labeled, width) {
        // Inline function 'com.lightningkite.kiteui.views.nav' call
        var this_0 = sizeConstraints(shownWhen(writer, false, VOID, this.showNav_1), VOID, VOID, VOID, VOID, VOID, width);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = get_asNavigation(themed(this_0, NavSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_debugName_wihv62_k$(labeled ? 'nav rail' : 'nav rail compact');
        element.set_showOnPrint_2epyu7_k$(false);
        applySafeInsets(element, VOID, false);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_2 = get_unpadded(sizeConstraints(shownWhen(element, VOID, VOID, ($this$shownWhen) => labeled), VOID, VOID, VOID, VOID, VOID, width));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (Link())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        var tmp2 = this.appLogoExpanded_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
        var description = this.appName_1;
        var scaleType = ImageScaleType_Fit_getInstance();
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RawImageView())(element_0.get_context_h02k06_k$(), tmp2, description, scaleType);
        ensureOutermostElement(element_1);
        element_0.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_1);
        element_0.set_accessibleLabel_97wje2_k$(this.appName_1 + ' home');
        element_0.set_to_opdqsp_k$(Nav$rail$lambda);
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        var tmp = get_centered(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_3 = sizeConstraints(shownWhen(tmp, VOID, VOID, ($this$shownWhen) => !labeled), VOID, VOID, VOID, VOID, VOID, width);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Link())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        var tmp0_elvis_lhs = this.appLogoCompact_1;
        var tmp2_0 = tmp0_elvis_lhs == null ? this.appLogoExpanded_1 : tmp0_elvis_lhs;
        // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
        var description_0 = this.appName_1;
        var scaleType_0 = ImageScaleType_Fit_getInstance();
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RawImageView())(element_2.get_context_h02k06_k$(), tmp2_0, description_0, scaleType_0);
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        element_2.set_accessibleLabel_97wje2_k$(this.appName_1 + ' home');
        element_2.set_to_opdqsp_k$(Nav$rail$lambda_0);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp$ret$17 = weight(element, 1.0);
        var tmp_0 = get_scrolling(themed(tmp$ret$17, ListSemantic_getInstance()));
        colOfExpensive(tmp_0, this.items_1, VOID, ($this$colOfExpensive, it) => {
          rail$item($this$colOfExpensive, labeled, this, it);
          return Unit_instance;
        });
        var tmp_1 = themed(shownWhen(element, false, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(this.footerItems_1).isEmpty_y1axqb_k$();
        }), ListSemantic_getInstance());
        colOfExpensive(tmp_1, this.footerItems_1, VOID, ($this$colOfExpensive, it) => {
          rail$item($this$colOfExpensive, labeled, this, it);
          return Unit_instance;
        });
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
      }
      drawer_pzgegy_k$(writer, closeAbove) {
        var tmp = closeAbove;
        if (!((tmp == null ? null : new (Dimension())(tmp)) == null)) {
          reactive(writer, VOID, ($this$reactive) => {
            var tmp;
            if (Dimension__compareTo_impl_gsceod($this$reactive.invoke_r7m7el_k$(AppState_getInstance().get_windowInfo_amgsav_k$()).width_1, closeAbove) > 0) {
              this.drawerOpen_1.set_value_v1vabv_k$(false);
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
        }
        var tmp_0 = Companion_getInstance_1().Fade_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        var this_0 = shownWhen(writer, false, tmp_0, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.drawerOpen_1) && this.showNav_1($this$shownWhen));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (DismissBackground())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        set_padding(element, get_px(0));
        element.set_debugName_wihv62_k$('nav drawer');
        element.set_showOnPrint_2epyu7_k$(false);
        element.onClick_tk88x3_k$(Nav$drawer$slambda(this));
        var tmp_1 = get_atStart(element);
        var tmp_2 = Companion_getInstance_1().FromLeft_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        var this_1 = shownWhen(tmp_1, false, tmp_2, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.drawerOpen_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (Frame())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.nav' call
        var this_2 = sizeConstraints(element_0, VOID, VOID, VOID, VOID, VOID, get_rem_0(17));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_3 = get_asNavigation(themed(this_2, NavSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(true);
        element_1.set_gap_jwjroq_k$(get_px(0));
        applySafeInsets(element_1, VOID, VOID, false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp$ret$11 = weight(element_1, 1.0);
        var tmp_3 = get_scrolling(themed(tmp$ret$11, ListSemantic_getInstance()));
        colOfExpensive(tmp_3, this.items_1, VOID, ($this$colOfExpensive, it) => {
          renderInline($this$colOfExpensive, it, this, this.selectedPath_1, Nav$drawer$lambda$slambda(this));
          return Unit_instance;
        });
        var tmp_4 = themed(shownWhen(element_1, false, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(this.footerItems_1).isEmpty_y1axqb_k$();
        }), ListSemantic_getInstance());
        colOfExpensive(tmp_4, this.footerItems_1, VOID, ($this$colOfExpensive, it) => {
          renderInline($this$colOfExpensive, it, this, this.selectedPath_1, Nav$drawer$lambda$slambda_0(this));
          return Unit_instance;
        });
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'Nav');
    NavClass = $;
  }
  return NavClass;
}
function navSidebar(_this__u8e3s4, appLogoCompact, appLogoExpanded, appLogoIcon, appName, expandedBreakpoint, compactBreakpoint, showNav, menuItems, footerItems, actionItems) {
  expandedBreakpoint = expandedBreakpoint === VOID ? get_rem_0(60) : expandedBreakpoint;
  compactBreakpoint = compactBreakpoint === VOID ? get_rem_0(40) : compactBreakpoint;
  var tmp;
  if (showNav === VOID) {
    tmp = navSidebar$lambda;
  } else {
    tmp = showNav;
  }
  showNav = tmp;
  var tmp_0;
  if (menuItems === VOID) {
    tmp_0 = navSidebar$lambda_0;
  } else {
    tmp_0 = menuItems;
  }
  menuItems = tmp_0;
  var tmp_1;
  if (footerItems === VOID) {
    tmp_1 = navSidebar$lambda_1;
  } else {
    tmp_1 = footerItems;
  }
  footerItems = tmp_1;
  var tmp_2;
  if (actionItems === VOID) {
    tmp_2 = navSidebar$lambda_2;
  } else {
    tmp_2 = actionItems;
  }
  actionItems = tmp_2;
  var nav = new (Nav())(_this__u8e3s4, appLogoExpanded, appLogoCompact, appLogoIcon, appName, showNav, menuItems, footerItems, actionItems);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, OuterSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  element.set_debugName_wihv62_k$('nav-sidebar');
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$4 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_1 = themed(tmp$ret$4, OuterSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Frame())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  applySafeInsets(element_0, VOID, false);
  element_0.set_debugName_wihv62_k$('nav and content');
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_2 = themed(element_0, OuterSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_3 = shownForQuery(element_1, new (MinWidth())(expandedBreakpoint));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Frame())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  nav.rail_uvsimf_k$(element_2, true, get_rem_0(16));
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_4 = shownForQuery(element_1, new (And())(setOf([new (MinWidth())(compactBreakpoint), new (MaxWidth())(expandedBreakpoint)])));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Frame())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_4.willAddChild_hz2iwc_k$(element_3);
  nav.rail_uvsimf_k$(element_3, false, get_rem(5.5));
  element_3.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$18 = weight(element_1, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_5 = themed(tmp$ret$18, OuterSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_5.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  nav.appBar$default_61bzdt_k$(element_4, new (MaxWidth())(compactBreakpoint));
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (Separator())(element_4.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_4.willAddChild_hz2iwc_k$(element_5);
  element_5.onStartup_vrxh3i_k$();
  element_4.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$26 = weight(element_4, 1.0);
  navigatorView(tmp$ret$26, get_pageNavigator(element_4.get_context_h02k06_k$()));
  element_4.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_4);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  nav.drawer_pzgegy_k$(element_0, compactBreakpoint);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (Frame())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  element.willAddChild_hz2iwc_k$(element_6);
  applySafeInsets(element_6, VOID, false);
  element_6.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_6);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function navBadge(_this__u8e3s4, count) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_0 = themed(_this__u8e3s4, NumberBadgeSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Frame())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_debugName_wihv62_k$('nav badge');
  if (count > 0) {
    text(textSize(get_centered(element), get_rem(0.75)), count.toString());
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_1 = sizeConstraints(element, VOID, VOID, VOID, VOID, VOID, get_rem(0.35), get_rem(0.35));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Space())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_1.willAddChild_hz2iwc_k$(element_0);
    element_0.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_0);
  }
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function accessibleName(_this__u8e3s4, full) {
  switch (_this__u8e3s4.get_count_ipufhi_k$()) {
    case null:
      return full;
    case 0:
      return full + ', has updates';
    default:
      return full + ', ' + _this__u8e3s4.get_count_ipufhi_k$();
  }
}
function navIconAndBadge(_this__u8e3s4, element) {
  var icon = element.get_icon_wont8i_k$();
  var count = element.get_count_ipufhi_k$();
  if (count == null) {
    if (!(icon == null)) {
      navIconAndBadge$navIcon(_this__u8e3s4, icon);
    }
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_0 = sizeConstraints(element_0, VOID, VOID, VOID, VOID, VOID, get_rem(2.25), get_rem_0(2));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Frame())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_0.willAddChild_hz2iwc_k$(element_1);
  if (!(icon == null)) {
    navIconAndBadge$navIcon(get_centered(element_1), icon);
  }
  navBadge(get_atTopEnd(element_1), count);
  element_1.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_0);
}
function navRowContent(_this__u8e3s4, element, disclosure) {
  disclosure = disclosure === VOID ? null : disclosure;
  if (element instanceof Custom()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
    element.wide_1(element_0);
    element_0.onStartup_vrxh3i_k$();
    _this__u8e3s4.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  var icon = element.get_icon_wont8i_k$();
  if (!(icon == null)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    var this_0 = get_centered(element_1);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (IconView())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_source_3o5lkf_k$(icon.copy$default_cqy5mq_k$(get_rem(1.5), get_rem(1.5)));
    element_2.set_description_s1386w_k$('');
    element_2.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_2);
  }
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var this_1 = get_centered(element_1);
  var tmp$ret$10 = weight(this_1, 1.0);
  text(tmp$ret$10, element.get_title_iz32un_k$());
  var tmp0_safe_receiver = element.get_count_ipufhi_k$();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    navBadge(get_centered(element_1), tmp0_safe_receiver);
  }
  if (!(disclosure == null)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    var this_2 = get_centered(element_1);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (IconView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    var tmp = KMutableProperty0();
    var tmp_0 = IconView$_get_source_$ref_hlcyij(element_3);
    var tmp_1 = getPropertyCallableRef('source', 0, tmp, tmp_0, IconView$_set_source_$ref_2j4ddb(element_3));
    element_3.invoke_bnq13k_k$(tmp_1, ($this$invoke) => ($this$invoke.invoke_r7m7el_k$(disclosure) ? Companion_getInstance().chevronDown_1 : Companion_getInstance().chevronRight_1).copy$default_cqy5mq_k$(get_rem_0(1), get_rem_0(1)));
    element_3.set_description_s1386w_k$('');
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
  }
  element_1.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_1);
}
function navStackedContent(_this__u8e3s4, element) {
  if (element instanceof Custom()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
    element.narrow_1(element_0);
    element_0.onStartup_vrxh3i_k$();
    _this__u8e3s4.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  navIconAndBadge(get_centered(element_1), element);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_centered(element_1);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = element.get_title_iz32un_k$();
  var tmp = element_2.native_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.set_content_i5lrjv_k$(tmp_0);
  element_2.set_wraps_9wisy1_k$(false);
  element_2.set_ellipsis_rhzl3b_k$(true);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_1);
}
function navTextContent(_this__u8e3s4, element) {
  if (element instanceof Custom()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
    element.wide_1(element_0);
    element_0.onStartup_vrxh3i_k$();
    _this__u8e3s4.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  }
  var count = element.get_count_ipufhi_k$();
  if (count == null) {
    text(_this__u8e3s4, element.get_title_iz32un_k$());
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  text(get_centered(element_1), element.get_title_iz32un_k$());
  navBadge(get_centered(element_1), count);
  element_1.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_1);
}
function navIconContent(_this__u8e3s4, element) {
  if (element instanceof Custom()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
    element.narrow_1(element_0);
    element_0.onStartup_vrxh3i_k$();
    _this__u8e3s4.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  }
  navIconAndBadge(_this__u8e3s4, element);
}
function renderInline(_this__u8e3s4, element, shell, selectedPath, select) {
  if (!(element instanceof Group())) {
    renderLeaf(_this__u8e3s4, element, selectedPath, select, ($this$renderLeaf) => {
      navRowContent($this$renderLeaf, element);
      return Unit_instance;
    });
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  var $this$col = element_0;
  var open = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$(shell.groupOverrides_1).get_wei43m_k$(element.title_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      var tmp$ret$5;
      $l$block: {
        var tmp0_elvis_lhs_0 = $this$remember.invoke_r7m7el_k$(selectedPath);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          tmp$ret$5 = false;
          break $l$block;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var selected = tmp_0;
        var navigator = get_mainPageNavigator($this$col.get_context_h02k06_k$());
        tmp$ret$5 = contains(element, selected, (it) => {
          var tmp0_safe_receiver = navigator.get_routes_j3zccz_k$().render_y0xm4o_k$(it);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.urlLikePath_1;
          return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.segments_1;
        });
      }
      tmp = tmp$ret$5;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  });
  $this$col.set_gap_jwjroq_k$(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed($this$col, UnselectedSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_0.willAddChild_hz2iwc_k$(element_1);
  element_1.set_accessibleLabel_97wje2_k$(accessibleName(element, element.fullTitle_1));
  navRowContent(element_1, element, open);
  onClick(element_1, VOID, VOID, VOID, renderInline$slambda(shell, element, open));
  element_1.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = shownWhen($this$col, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(open));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(false);
  element_2.set_gap_jwjroq_k$(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Space())(element_2.get_context_h02k06_k$(), 0.5);
  ensureOutermostElement(element_3);
  element_2.willAddChild_hz2iwc_k$(element_3);
  element_3.onStartup_vrxh3i_k$();
  element_2.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$16 = weight(element_2, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_2 = themed(tmp$ret$16, ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_2.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  element_4.set_gap_jwjroq_k$(get_px(0));
  var _iterator__ex2g4s = element.children_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var child = _iterator__ex2g4s.next_20eer_k$();
    renderInline(element_4, child, shell, selectedPath, select);
  }
  element_4.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_4);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element_0);
}
function renderAsMenus(_this__u8e3s4, element, direction, selectedPath, select, content) {
  var tmp;
  if (select === VOID) {
    tmp = renderAsMenus$slambda();
  } else {
    tmp = select;
  }
  select = tmp;
  if (!(element instanceof Group())) {
    renderLeaf(_this__u8e3s4, element, selectedPath, select, content);
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  var this_0 = selectedIfContains(_this__u8e3s4, element, selectedPath);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (MenuButton())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_accessibleLabel_97wje2_k$(accessibleName(element, element.fullTitle_1));
  content(element_0);
  element_0.set_preferredDirection_gql2kx_k$(direction);
  element_0.opensMenu_gggyad_k$(($this$opensMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = themed($this$opensMenu, ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    var _iterator__ex2g4s = element.children_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var child = _iterator__ex2g4s.next_20eer_k$();
      var tmp = renderAsMenus$lambda$slambda(element_0);
      renderAsMenus(element_0, child, direction, selectedPath, tmp, renderAsMenus$lambda$lambda(child));
    }
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
    return Unit_instance;
  });
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
}
function renderLeaf(_this__u8e3s4, element, selectedPath, select, content) {
  if (element instanceof Action()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Button())(_this__u8e3s4.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
    element_0.set_accessibleLabel_97wje2_k$(accessibleName(element, element.title_1));
    content(element_0);
    onClick(element_0, VOID, VOID, VOID, renderLeaf$slambda(element, select));
    element_0.onStartup_vrxh3i_k$();
    _this__u8e3s4.addChild_2qpft2_k$(element_0);
  } else {
    if (element instanceof Link_0()) {
      // Inline function 'com.lightningkite.kiteui.views.direct.link' call
      var this_0 = selectedIfCurrent(_this__u8e3s4, element, selectedPath);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Link())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_0.willAddChild_hz2iwc_k$(element_1);
      content(element_1);
      element_1.resetsStack_1 = true;
      element_1.set_to_opdqsp_k$(element.to_1);
      element_1.set_accessibleLabel_97wje2_k$(accessibleName(element, element.fullTitle_1));
      onNavigate_0(element_1, VOID, VOID, VOID, renderLeaf$slambda_0(select));
      element_1.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element_1);
    } else {
      if (element instanceof External()) {
        // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
        var this_1 = themed(_this__u8e3s4, UnselectedSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (ExternalLink())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_1.willAddChild_hz2iwc_k$(element_2);
        content(element_2);
        element_2.set_to_ulc74x_k$(element.to_1);
        element_2.set_accessibleLabel_97wje2_k$(accessibleName(element, element.fullTitle_1));
        onNavigate(element_2, VOID, VOID, VOID, renderLeaf$slambda_1(select));
        element_2.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_2);
      } else {
        if (element instanceof Custom())
          content(_this__u8e3s4);
        else {
          if (element instanceof Group())
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("Groups are handled by the caller's group strategy, not by renderLeaf");
          else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
}
function navSelectedPath(_this__u8e3s4, items) {
  return remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var navigator = get_mainPageNavigator(_this__u8e3s4.get_context_h02k06_k$());
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(navigator.currentPage_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = navigator.get_routes_j3zccz_k$().render_y0xm4o_k$(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.urlLikePath_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.segments_1;
    var tmp_0;
    if (tmp3_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp3_elvis_lhs;
    }
    var current = tmp_0;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = allLinks($this$remember.invoke_r7m7el_k$(items));
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp0_safe_receiver_0 = navigator.get_routes_j3zccz_k$().render_y0xm4o_k$(element.to_1());
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.urlLikePath_1;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.segments_1;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver_1);
      }
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (element_0.get_size_woubt6_k$() <= current.get_size_woubt6_k$() && equals(current.subList_xle3r2_k$(0, element_0.get_size_woubt6_k$()), element_0)) {
        destination_0.add_utx5q5_k$(element_0);
      }
    }
    var tmp$ret$12;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator = destination_0.iterator_jk1svi_k$();
      if (!iterator.hasNext_bitz1p_k$()) {
        tmp$ret$12 = null;
        break $l$block_0;
      }
      var maxElem = iterator.next_20eer_k$();
      if (!iterator.hasNext_bitz1p_k$()) {
        tmp$ret$12 = maxElem;
        break $l$block_0;
      }
      var maxValue = maxElem.get_size_woubt6_k$();
      do {
        var e = iterator.next_20eer_k$();
        var v = e.get_size_woubt6_k$();
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.hasNext_bitz1p_k$());
      tmp$ret$12 = maxElem;
    }
    return tmp$ret$12;
  });
}
function allLinks(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp;
    if (element instanceof Group()) {
      tmp = allLinks(element.children_1);
    } else {
      if (element instanceof Link_0()) {
        tmp = listOf(element);
      } else {
        var tmp_0;
        if (element instanceof External()) {
          tmp_0 = true;
        } else {
          var tmp_1;
          if (element instanceof Action()) {
            tmp_1 = true;
          } else {
            tmp_1 = element instanceof Custom();
          }
          tmp_0 = tmp_1;
        }
        if (tmp_0) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var list = tmp;
    addAll(destination, list);
  }
  return destination;
}
function contains(_this__u8e3s4, path, pathOf) {
  var tmp;
  if (_this__u8e3s4 instanceof Group()) {
    var tmp0 = _this__u8e3s4.children_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (contains(element, path, pathOf)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  } else {
    if (_this__u8e3s4 instanceof Link_0()) {
      tmp = equals(pathOf(_this__u8e3s4.to_1()), path);
    } else {
      var tmp_1;
      if (_this__u8e3s4 instanceof External()) {
        tmp_1 = true;
      } else {
        var tmp_2;
        if (_this__u8e3s4 instanceof Action()) {
          tmp_2 = true;
        } else {
          tmp_2 = _this__u8e3s4 instanceof Custom();
        }
        tmp_1 = tmp_2;
      }
      if (tmp_1) {
        tmp = false;
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return tmp;
}
function selectedIfContains(_this__u8e3s4, group, selectedPath) {
  return dynamicThemed(_this__u8e3s4, ($this$dynamicThemed) => {
    var selected = $this$dynamicThemed.invoke_r7m7el_k$(selectedPath);
    var navigator = get_mainPageNavigator(_this__u8e3s4.get_context_h02k06_k$());
    var tmp;
    if (!(selected == null)) {
      tmp = contains(group, selected, (it) => {
        var tmp0_safe_receiver = navigator.get_routes_j3zccz_k$().render_y0xm4o_k$(it);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.urlLikePath_1;
        return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.segments_1;
      });
    } else {
      tmp = false;
    }
    var holdsCurrentPage = tmp;
    return holdsCurrentPage ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance();
  });
}
function selectedIfCurrent(_this__u8e3s4, link, selectedPath) {
  return dynamicThemed(_this__u8e3s4, ($this$dynamicThemed) => {
    var navigator = get_mainPageNavigator(_this__u8e3s4.get_context_h02k06_k$());
    var tmp0_safe_receiver = navigator.get_routes_j3zccz_k$().render_y0xm4o_k$(link.to_1());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.urlLikePath_1;
    var own = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.segments_1;
    return !(own == null) && equals(own, $this$dynamicThemed.invoke_r7m7el_k$(selectedPath)) ? SelectedSemantic_getInstance() : UnselectedSemantic_getInstance();
  });
}
function navSidebar$lambda(_this__u8e3s4) {
  return true;
}
function navSidebar$lambda_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function navSidebar$lambda_1(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function navSidebar$lambda_2(_this__u8e3s4) {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function navIconAndBadge$navIcon(_this__u8e3s4, icon) {
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (IconView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_source_3o5lkf_k$(icon.copy$default_cqy5mq_k$(get_rem(1.5), get_rem(1.5)));
  element.set_description_s1386w_k$('');
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function IconView$_get_source_$ref_hlcyij(p0) {
  return constructCallableReference(() => p0.source_1, 0, 0, 192, VOID, [p0]);
}
function IconView$_set_source_$ref_2j4ddb(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_source_3o5lkf_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 193, VOID, [p0]);
}
function renderInline$slambda($shell, $element, $open) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $shell.groupOverrides_1.set_value_v1vabv_k$(plus($shell.groupOverrides_1.get_value_j01efc_k$(), to($element.title_1, !(yield* awaitOnce($open, $completion)))));
    return Unit_instance;
  }), 0);
}
function renderAsMenus$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return Unit_instance;
  }), 0);
}
function renderAsMenus$lambda$slambda($$this$col) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    closePopovers($$this$col.get_context_h02k06_k$());
    return Unit_instance;
  }), 0);
}
function renderAsMenus$lambda$lambda($child) {
  return ($this$renderAsMenus) => {
    navRowContent($this$renderAsMenus, $child);
    return Unit_instance;
  };
}
function renderLeaf$slambda($element, $select) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($element.onSelect_1($completion), $completion);
    yield* $($select($completion), $completion);
    return Unit_instance;
  }), 0);
}
function renderLeaf$slambda_0($select) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($select($completion), $completion);
    return Unit_instance;
  }), 0);
}
function renderLeaf$slambda_1($select) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($select($completion), $completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  Action as Action27adr0bswxodr,
  Custom as Custom2ic00hnkt7wt3,
  Group as Group2011jxjxf0ish,
  Link_0 as Link1sktol1xxfdlo,
  navSidebar as navSidebar3k1gob5isog5l,
};
//endregion

//# sourceMappingURL=forked-nav.mjs.map
